<template>
  <div style="padding-bottom: 64px;">
    <van-nav-bar
      title="教育经历"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar>
    <div class="form">
      <van-cell-group class="form-cont">
        <van-field input-align="right" label="学校名称" value='' placeholder="请输入有效学校名称" />
        <van-field
          readonly
          clickable
          label="学历"
          input-align="right"
          is-link
          :value="value"
          placeholder="请选择真实学历"
          @click="showPicker = true"
        />
        <van-field
          input-align="right"
          readonly
          clickable
          placeholder="请选择真实信息"
          @click="showPicker = true"
          is-link
          label="是否拥有学位">
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          @click="showPicker = true"
          placeholder="请选择有效专业"
          is-link
          label="所学专业">
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          @click="schoolTime = true"
          placeholder="请选择真实在校时间"
          is-link
          label="在校时间">
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          @click="showPicker = true"
          placeholder="请选择真实信息"
          is-link
          label="是否有海外学习经历">
        </van-field>

      </van-cell-group>
    </div>

    <div class="fixed-bottom">
      <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>保 存</van-button>
    </div>

    <!--选择弹框-->
    <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!--选择生日-->
    <van-popup v-model="schoolTime" round position="bottom" style="width: 100%;">
      <van-tabs title-active-color="#2D6FF2" v-model="active" :ellipsis="false">
        <van-tab>
          <template #title> <p>入学时间</p><span>{{enterTime}}</span> </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate"
            type="year-month"
            visible-item-count="3"
            item-height="50"
            @confirm="onConfirmEnterTime"
            :formatter="formatter"
          />
        </van-tab>
        <van-tab>
          <template #title>
            <p>离校时间</p>
            <span> {{leaveTime}}</span>
          </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate"
            type="year-month"
            visible-item-count="3"
            item-height="50"
            @confirm="onConfirmleaveTime"
            :formatter="formatter"
          />
        </van-tab>
      </van-tabs>
      <button class="btn-default">确定</button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'education',
  data() {
    return {
      active: 1,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      enterTime: '2020.11.12',
      leaveTime: '2020.11.12',
      value: '',
      schoolTime: '',
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      showPicker: false
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onConfirm(value) {
      this.value = value
      this.showPicker = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onConfirmEnterTime() {
      this.enterTime = this.currentDate.getFullYear() + '-' +
        (Number(this.currentDate.getMonth()) + 1) +
        '-' +
        this.currentDate.getDate()
    },
    onConfirmleaveTime() {
      this.leaveTime = this.currentDate.getFullYear() + '-' +
        (Number(this.currentDate.getMonth()) + 1) +
        '-' +
        this.currentDate.getDate()
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/.van-cell{
    padding:20px 16px;
  }
  /deep/.van-hairline--top-bottom::after,/deep/.van-hairline-unset--top-bottom::after{
    display: none;
  }
  /deep/.van-cell__right-icon{
    transform: rotate(90deg);
    top:-4px;
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:2;
    }
    .btn-org-border{
      border:1px solid #FF5945!important;
      box-shadow: none;
      margin-right: 16px;
      flex:1;
      color:#FF5945;
      .van-button__text{
        color:#FF5945;
      }
    }
  }
  /deep/.form-cont .van-field__label{
    white-space: nowrap;
  }
  /deep/.van-tabs--line .van-tabs__wrap{
    height: 72px;
    border-bottom: 1px solid #eee;
  }
  /deep/.van-tab__text{
    text-align: center;
    padding:10px;
    display: block;
    p{
      font-size: 12px;
      transform: rotate(.9);
      color:#5C5D5F
    }
    span{
      font-size: 16px;
      color:#5C5D5F;
      opacity: .5;
    }
  }
  /deep/.van-tab.van-tab--active{
    span{
      color:#2D6FF2;
      opacity: 1;
    }
  }
  /deep/.van-tabs__line{
    background:#2D6FF2;
    width: 50%;
    margin-bottom: -1px;
    z-index: 999;
  }
  /deep/.van-picker-column__item{
    .van-ellipsis{
      font-size: 18px;
    }
  }
  .btn-default{
    color:#2A2B2C;
    width: 100%;
    font-size: 16px;
    display: block;
    border:none;
    text-align: center;
    border-top:1px solid #eee;
    padding:16px 0;
    background: none;
  }
  /deep/.van-popup{
    min-height: auto;
    .van-tabs__nav{
      border-radius: 16px 16px 0 0;
    }
  }
</style>
